import { useCallback } from 'react';
import PopupNg from '@/ui/PopupNg';
import InfoIcon from '@/icons/InfoIcon';
import React from 'react';

export function InstanceInfo({ text }) {
    const handleClick = useCallback(
        function handleClick(e) {
            e.stopPropagation();
            PopupNg.dispatcher.open('dialog/message', { bodyText: text });
        },
        [text]
    );
    return (
        <div className="live-match-info" onClick={handleClick}>
            <InfoIcon width={20} height={20} fill={'#656d78'} opacity={0.8} />
        </div>
    );
}
